module.exports = __webpack_public_path__ + "static/index/img/baikal-401.f431e755.jpg";